import { useFireSessionContext } from '@chilipiper/fire-session'
import { useUser } from '@/api/workspace'

export const useUserHasConciergeLiveLicense = () => {
  const { isTiered, features } = useFireSessionContext()
  const { data: user } = useUser()

  if (isTiered) {
    return features.has('ConciergeLive')
  }
  return user?.licenses.conciergeLive
}
